import React, { useState } from "react";
import Modal from "../../../components/common/form/Modal";
import ButtonTray from "../../../components/common/form/ButtonTray";
import { useCancelOrderOnLocateMutation } from "../ordersApi";
import { showToast } from "../../../helpers/utils/Utils";

interface LockConfirmationPopUpProps {
    formType: string;
    show: boolean;
    setShow: (show: boolean) => void;
    orderId?: number | string;
    setEditable: (editable: boolean) => void;
    productId: number | string;
}

const LockConfirmationPopUp: React.FC<LockConfirmationPopUpProps> = ({
                                                                         formType,
                                                                         show,
                                                                         setShow,
                                                                         orderId,
                                                                         setEditable,
                                                                         productId,
                                                                     }) => {
    const [cancelOrderOnLocate, { isLoading }] = useCancelOrderOnLocateMutation();

    const cancelOrder = async () => {
        try {
            const response = await cancelOrderOnLocate({ orderId, productId }).unwrap();

            if (response?.errorCode === 200) {
                showToast("Locate request canceled successfully!", "success");
                setEditable(true);
            } else {
                showToast(response?.message || "Failed to cancel locate request.", "error");
            }
        } catch (error: any) {
            showToast(error?.data?.message || error?.message || "Something went wrong", "error");
        } finally {
            setShow(false);
        }
    };

    return (
        <Modal
            title="Awaiting Locate"
            show={show}
            setShow={setShow}
            className="w-2/5 bg-text-0 text-surface-0"
            hoa={formType === "HOA"}
            fields={
                <div>
                    <ButtonTray
                        buttons={[
                            {
                                buttonType: "button",
                                buttonProps: {
                                    btnText: "Continue with Locked Editor",
                                    onClick: () => setShow(false),
                                    isHoa: formType === "HOA",
                                    type: "button",
                                    isDisabled: isLoading
                                },
                            },
                            {
                                buttonType: "button",
                                buttonProps: {
                                    btnText: "Cancel Locate & Unlock Editor",
                                    onClick: (e) => {
                                        e.preventDefault();
                                        cancelOrder();
                                    },
                                    isLoading,
                                    isHoa: formType === "HOA",
                                    type: "button",
                                },
                            },
                        ]}
                        align="end"
                        gap={2}
                    />
                </div>
            }
        />
    );
};

export default LockConfirmationPopUp;
